import React, { Component } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import { add, sub, format } from 'date-fns'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Paper, Dropdown, Tabs } from 'components'
import { DateSelector } from 'features'
import { FaChevronLeft, FaChevronRight, FaFilter, FaShare } from 'react-icons/fa'
import FilterOptions from './FilterOptions'

import * as actionCreators from 'store/actions'

const Wrapper = styled.div`
    display: flex;
    flex-direction: ${props => props.direction || 'column'};
    justify-content: center;
    align-items: center;
    background-color: ${props => props.style && props.style.backgroundColor};
    padding: ${props => props.style && props.style.padding};
    border-radius: ${props => props.style && props.style.borderRadius};
    box-sizing: border-box;
    border: 1px solid var(--primary-accent-color);
`

const Title = styled.div`
    /* font-weight: bolder; */
    font-size: 0.8rem;
`

const Container = styled.div`
    display: flex;
    align-items: center;
    width: ${props => props.width};
    justify-content: space-between;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 5;
    background-color: ${props => props.styles.primaryColor};
    border-bottom: 1px solid var(--primary-accent-color);
    padding-bottom: 0.5rem;
`

const Section = styled.div`
    display: flex;
    align-items: center;
    width: ${props => props.width};
    justify-content: space-between;
    position: sticky;
    position: -webkit-sticky;
    top: 0;
    z-index: 1;
    background-color: ${props => props.styles.primaryColor};
`

const DateTitle = props => {
    const {
        type,
        date,
        onSelect,
        onRange,
        styles,
        filters,
        onFilter,
        forward, 
        events,
    } = props;

    // Redux
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS())
    const uid = useSelector((state) => state.auth.uid)
    const sessionId = useSelector((state) => state.content.sessionId)
    const dispatch = useDispatch()
    const forwardSchedule = (data, uid) => {
        dispatch(actionCreators.forwardSchedule(date, events, data, uid, sessionId))
    }

    const rangeOptions = {
        day: 'Day',
        week: 'Week',
        month: 'Month'
    }

    // Styles
    const defaultStyle = {
        primaryColor: 'var(--secondary-color)',
        secondaryColor: 'var(--secondary-color)',
        secondaryColor2: 'var(--primary-accent2-color)',
    }
    const updatedStyle = Object.assign({}, defaultStyle, styles)

    const buttonStyle = {
        backgroundColor: updatedStyle['primaryColor'],
        margin: '0 1px 0 0',
        borderColor: 'transparent',
        fontSize: '0.8rem',
        padding: '0.3rem',
        boxShadowColor: 'transparent'
    }

    const dropdownStyle = {
        backgroundColor: updatedStyle['secondaryColor'],
        fontSize: '0.8rem',
        padding: '0.3rem 0.5rem',
        // width: 'fit-content',
        placement: 'bottom-start',
        border: `1px solid var(--primary-accent2-color)`,
        minWidth: '5rem',
        margin: '0 0.5rem 0 0'
    }

    // Handlers
    const toggleDate = direction => {
        const amount = type === 'day' ? {days: 1}
                        : type === 'week' ? {weeks: 1}
                        : {months: 1}
        let updatedDate = direction === 'add' ? date.add(amount) 
                        : direction === 'sub' ? date.subtract(amount)
                        : date
        onSelect && onSelect(updatedDate)
    }

    const toggleRange = option => {
        onRange && onRange(option)
    }

    const forwardHandler = () => {
        // const d = format(date, 'LLL d Y')
        const d = date.format('MMM D Y')
        const schedule = data['schedules'] && data['schedules'][d]
        console.log('[DateTitle]',d, schedule)
        // schedule && forwardSchedule(schedule, data, uid)
        forwardSchedule(data, uid)
        
    }

    // Elements
    const dateFormat = type === 'day' ? 'ddd, D MMM Y'
                : type === 'week' ? 'D MMM Y'
                : 'MMM Y'

    const DateHeader = <Title>{date.format(dateFormat)}</Title>
    const DatePicker = <Paper>
                            <Wrapper style={{backgroundColor: updatedStyle['secondaryColor'], padding: '0.5rem', borderRadius: '5px'}}>
                                <DateSelector type='date' date={date} onSelect={onSelect}/>
                            </Wrapper>
                        </Paper>

return (
        <Container width='100%' styles={updatedStyle}>
            <div style={{display: 'flex', alignItems: 'center'}}>
                {/* <Dropdown options={rangeOptions} onSelect={toggleRange} style={dropdownStyle} value={rangeOptions[type]}/> */}
                <Tabs onSelect={(value) => toggleRange(value)} 
                    options={{day: 'Day', week: 'Week', month: 'Month'}} 
                    // icons={{ASCENDING: <FaSortAmountUp/>, DESCENDING: <FaSortAmountUpAlt/>}}
                    selected={type}
                    styles={{
                        main: {
                            width: '100%',
                            backgroundColor: 'var(--primary-color)',
                            fontWeight: 'normal',
                            fontSize: '0.8rem',
                            margin: '0 0.25rem 0 0'
                        },
                        tab: {
                            width: null,
                            padding: '0.25rem 0.5rem',
                            fontWeight: 'normal',
                            fontSize: '0.8rem'
                        }
                    }}/>
                {forward && <Button icon={<FaShare/>} tooltip='Forward incomplete items to the next day' onSelect={forwardHandler} styles={buttonStyle}/>}
            </div>
            
            <Section styles={updatedStyle}>
                <Button icon={DateHeader} contextMenu={DatePicker} placement='bottom' styles={buttonStyle}/>

                {onFilter ? 
                <Button iconOnly icon={<FaFilter/>} styles={buttonStyle} 
                    contextMenu={<FilterOptions filters={filters} onFilter={onFilter} styles={updatedStyle} view={type}/>}
                    tooltip='Filter'/> : null}
                <Button iconOnly icon={<FaChevronLeft/>} styles={buttonStyle} 
                    onSelect={() => toggleDate('sub')} 
                    tooltip={`Prev ${type}`}/>
                <Button iconOnly icon={<FaChevronRight/>} styles={buttonStyle} 
                    onSelect={() => toggleDate('add')} 
                    tooltip={`Next ${type}`}/>
            </Section>
        </Container>
    )
}

export default DateTitle